import api from '../../../services/api';

/**
 * Endpoints do M8 com o nome do domínio.
 *
 * ⚠️ Repasse fino para `services/api.js`, onde os endpoints do projeto moram.
 * Existe só para as telas lerem `CloseShipment(...)` em vez de
 * `api.closeWarehouseShipment(...)` — nenhuma regra, nenhum transporte próprio.
 */
export function ListShipments(params = {}) {
    return api.getWarehouseShipments(params);
}

export function GetShipment(id) {
    return api.getWarehouseShipment(id);
}

export function CreateShipment(data) {
    return api.createWarehouseShipment(data);
}

export function AddShipmentItems(id, data) {
    return api.addWarehouseShipmentItems(id, data);
}

/** "Excluir" item do checklist é PATCH {active:false} — sem DELETE (§3). */
export function RemoveShipmentItem(id, itemId) {
    return api.removeWarehouseShipmentItem(id, itemId);
}

/**
 * Bipe do carregamento: SÓ a etiqueta do LPN/volume (`{code, scan_method,
 * operator_code}`).
 *
 * ⚠️ `dock_code` saiu do corpo em 13/08 — o dono cortou o bipe da doca no
 * embarque. Mandá-lo agora é 400: o wire não aceita campo que a regra não usa.
 */
export function ScanShipmentItem(id, data) {
    return api.scanWarehouseShipmentItem(id, data);
}

/**
 * FECHAR — vai com **FormData** (a mídia do carregamento viaja junto), por isso
 * não passa por serialização JSON. A trava de 100% é REFEITA no servidor: 409
 * depois de a tela mostrar 100% significa que o CHECKLIST MUDOU, não que a tela
 * errou.
 */
export function CloseShipment(id, formData) {
    return api.closeWarehouseShipment(id, formData);
}

export function CancelShipment(id, data = {}) {
    return api.cancelWarehouseShipment(id, data);
}

/** Romaneios do módulo legado — o embarque é a sessão de carregamento DELES. */
export function ListOutbounds(params = {}) {
    return api.getOutbounds(params);
}

/** Docas ativas, para escolher ONDE o caminhão está ao abrir o embarque. */
export function ListDockLocations() {
    return api.getWarehouseLocations({ type: 'DOCK', status: 'ACTIVE', limit: 200 });
}

/**
 * A fila do espelho: é ela que responde "por que o Bling não atualizou?" — e,
 * desde 13/08, "em qual DEPÓSITO", porque o espelho é 1‑para‑1.
 */
export function ListBlingSyncQueue(params = {}) {
    return api.getBlingSyncQueue(params);
}

export function RequeueBlingSync(data = {}) {
    return api.requeueBlingSyncQueue(data);
}
